<template>
    <div
        class="quantity-stepper-small flex flex-row items-center flex-shrink-0 select-none"
        :class="
            isCardStyle
                ? 'absolute top-1/2 left-1/2 transform -translate-x-1/2 bg-white scale-90 shadow rounded-full justify-center gap-1 w-24 py-1.5'
                : 'ml-2 relative w-auto justify-between'
        "
    >
        <div class="flex items-center cursor-pointer" @click="change(-1)">
            <bin-icon v-if="value === 1" class="text-secondaryactions" />
            <minus-circle-icon v-else class="w-5 h-5 flex-shrink-0" />
        </div>
        <div class="w-6 text-center text-primary">{{ value }}</div>
        <div
            class="flex items-center cursor-pointer"
            :class="{ 'opacity-50': value >= multiMax || disabled }"
            @click="change(1)"
        >
            <plus-circle-icon class="w-5 h-5 flex-shrink-0" />
        </div>
    </div>
</template>

<script>
import PlusCircleIcon from '@/components/icons/PlusCircleIcon.vue';
import MinusCircleIcon from '@/components/icons/MinusCircleIcon.vue';
import BinIcon from '@/components/icons/BinIcon.vue';

export default {
    name: 'QuantityStepper',
    model: { prop: 'value', event: 'input' },
    components: {
        BinIcon,
        MinusCircleIcon,
        PlusCircleIcon
    },
    props: {
        value: { type: Number, required: true },
        multiMax: { type: Number, required: true },
        inventory: { type: Number, default: Infinity },
        disabled: { type: Boolean, default: false },
        isCardStyle: { type: Boolean, default: false }
    },
    computed: {
        maxAllowed() {
            return Math.min(this.multiMax, this.inventory);
        }
    },
    methods: {
        change(delta) {
            if (delta > 0 && this.disabled) return;

            const newQ = this.value + delta;

            if (newQ > this.maxAllowed) return;

            this.$emit('input', newQ);
        }
    }
};
</script>
